import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const __default__ = {
    name: 'LandingPage',
    mounted() {
        const utmSource = this.$route.query.utm_source;
        if (utmSource) {
            localStorage.setItem('utmSource', utmSource);
        }
    }
};
import { useFullWidth } from '@/composables/useFullWidth';
import CustomerReviews from '@/views/landing/CustomerReviews.vue';
import DiscussAndCollaborate from '@/views/landing/DiscussAndCollaborate.vue';
import EasySetUp from '@/views/landing/EasySetUp.vue';
import LandingHero from '@/views/landing/LandingHero.vue';
import LandingPageFooter from '@/views/landing/LandingPageFooter.vue';
import StartFree from '@/views/landing/StartFree.vue';
import TimeboxedFlow from '@/views/landing/TimeboxedFlow.vue';
import WriteInPrivate from '@/views/landing/WriteInPrivate.vue';
export default /*#__PURE__*/ _defineComponent({
    ...__default__,
    setup(__props) {
        useFullWidth();
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(LandingHero),
                _createVNode(EasySetUp),
                _createVNode(TimeboxedFlow),
                _createVNode(WriteInPrivate),
                _createVNode(DiscussAndCollaborate),
                _createVNode(CustomerReviews),
                _createVNode(StartFree),
                _createVNode(LandingPageFooter)
            ]));
        };
    }
});
